module.exports = __webpack_public_path__ + "static/media/kitchen-8.591b1a00.jpg";